<template>
  <div class="space-y-4 bg-surface-grey-light rounded-md">
    <div
      class="bg-surface-light p-4 border-surface-grey rounded-sm flex items-start justify-between gap-4"
    >
      <div class="space-y-1 min-w-0">
        <!-- Event name and details, max 50 chars, 1 line -->
        <div class="font-semibold text-sm truncate">{{ getLocalizedCartItemValue(item, locale, 'info1') }}</div>
        <div class="text-xs text-text capitalize truncate">{{ getDisplayDate(item, locale) }}</div>
        <div class="text-xs text-text truncate">{{ item.venueName }}</div>
      </div>
      <img
        :src="item.image"
        :alt="item.name"
        class="w-25 aspect-100/56 rounded-sm object-cover border border-surface-grey"
      />
    </div>
    <!-- Tickets -->
    <CartItemSection
      v-if="item.tickets && item.tickets.length"
      :heading="$t('checkout.tickets').toUpperCase()"
      :items="item.tickets"
      :id="item.id"
      type="ticket"
    />
    <!-- Add-ons -->
    <CartItemSection
      v-if="item.addons && item.addons.length"
      :id="item.id"
      :heading="$t('checkout.addons').toUpperCase()"
      :items="item.addons"
      type="addon"
    />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import type { CartItem } from '@/types';
  import { getDisplayDate, getLocalizedCartItemValue } from '@/utils/cartItemUtil';

  import CartItemSection from './CheckoutItemSection.vue';
  const { locale } = useI18n();

  defineProps<{ item: CartItem }>();
</script>
